export default __webpack_public_path__ + "static/media/humane_society.7e9a86cd.png";